<button [disabled]="saving$ | async" 
 mat-raised-button
 color="primary"
 (click)="saveForm()" style="flex: auto">
  <mat-icon>save</mat-icon>
  {{'form.save' | translate}}
</button>